module.exports = __webpack_public_path__ + "img/shichangyingxiao.59a3a6ec.png";